import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initInfos(element) {
    const withPagination = element.querySelector('.nav-desktop');

    const swiper = new Swiper(element.querySelector('.swiper-infos'), {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 24,
        breakpoints: {
            768: {
                slidesPerView: withPagination ? 'auto' : 0,
                spaceBetween: withPagination ? 47 : 0,
            },
        },
        navigation: {
            nextEl: element.querySelector('.swiper-infos .swiper-button-next'),
            prevEl: element.querySelector('.swiper-infos .swiper-button-prev'),
        },
    });

    //Pode não existir o elemento caso o componente não tenha "pagination:true"
    if (withPagination) {
        element.querySelector('.nav-desktop .swiper-button-next').addEventListener('click', function (evt) {
            swiper.slideNext();
        });

        element.querySelector('.nav-desktop .swiper-button-prev').addEventListener('click', function (evt) {
            swiper.slidePrev();
        });
    }
}

function initAllInfos() {
    document.querySelectorAll('.infos').forEach(function (element) {
        initInfos(element);
    });
}

domContentLoadEvent(initAllInfos);
